import React, { Fragment } from 'react';
import axios from 'axios'
import Qs from 'qs';
import { Link } from 'react-router-dom';
import Gallery from "react-photo-gallery";
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css'; // This only needs to be imported once in your app

import PerfectScrollbar from 'react-perfect-scrollbar';

import {
    Row,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    ListGroup,
    CardHeader,
    Card,
    Button,
    Progress,
    Input
} from 'reactstrap';

import Swal from 'sweetalert2'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getRealImageSrc, clearSession } from 'session';

export default class EventsList extends React.Component {

    constructor(props) {
        super(props);
        this.state = { items: [], lang_version: props.lang_version, is_admin: 0, searchValue: "", current_lightbox_images: [], currentPostImageIndex: 0, viewerIsOpen: false }
    }

    static getDerivedStateFromProps(props, state) {
        let new_state = {};
        let flag = false;
        if (props.lang_version !== state.lang_version) {
            new_state.lang_version = props.lang_version;
            flag = true;
        }

        if (flag) {
            return new_state;
        }
        return null;
    }

    componentDidMount() {
        document.getElementById("post_modal_loader").style.display = "block";
        let session = window.localStorage;
        axios.post(session.ch_action_url + "/action/get_all_posts", Qs.stringify({
            token: session.ch_token,
            lang: this.state.lang_version === "ch" ? 2 : 1
        })).then(res => {
            document.getElementById("post_modal_loader").style.display = "none";
            if (res.data.status === -1) {
                clearSession();
            }
            else if (res.data.status === 0) {
                Swal.fire(
                    'Operation Failed!',
                    res.data.info,
                    'error');
                this.setState({ isLoading: false });

            }
            else {
                let items = res.data.data;
                this.setState({ items: items, is_admin: res.data.is_admin });
            }
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.lang_version !== prevState.lang_version) {
            document.getElementById("post_modal_loader").style.display = "block";
            let session = window.localStorage;
            axios.post(session.ch_action_url + "/action/get_all_posts", Qs.stringify({
                token: session.ch_token,
                lang: this.state.lang_version === "ch" ? 2 : 1
            })).then(res => {
                document.getElementById("post_modal_loader").style.display = "none";
                if (res.data.status === -1) {
                    clearSession();
                }
                else if (res.data.status === 0) {
                    Swal.fire(
                        'Operation Failed!',
                        res.data.info,
                        'error');
                    this.setState({ isLoading: false });

                }
                else {
                    let items = res.data.data;
                    this.setState({ items: items, is_admin: res.data.is_admin });
                }
            });
        }

        if (this.state.searchValue !== prevState.searchValue) {
            // let session = window.localStorage;
            // axios.post(session.ch_action_url + "/action/get_all_posts", Qs.stringify({
            //     token: session.ch_token,
            //     root_user:this.state.root_user,
            //     lang: this.state.lang_version === "ch" ? 2 : 1
            // })).then(res => {
            //     if (res.data.status === -1) {
            //         clearSession();
            //     }
            //     else if (res.data.status === 0) {
            //         Swal.fire(
            //             'Operation Failed!',
            //             res.data.info,
            //             'error');
            //         this.setState({ isLoading: false });

            //     }
            //     else {
            //         let items = res.data.data;
            //         this.setState({ items: items });
            //     }
            // });
        }
    }

    handlePostActions(e, action_name, id, value) {
        if (e != null) {
            e.preventDefault();
        }

        if (action_name === "top_action") {
            let session = window.localStorage;
            axios.post(session.ch_action_url + "/action/update_post_top_status", Qs.stringify({
                token: session.ch_token,
                id: id,
                value: value
            })).then(res => {
                if (res.data.status === -1) {
                    clearSession();
                }
                else if (res.data.status === 0) {
                    Swal.fire(
                        'Operation Failed!',
                        res.data.info,
                        'error');
                }
                else {
                    let items = this.state.items;
                    for (let i = 0; i < items.length; i++) {
                        if (items[i].id === id) {
                            items[i].top = value;
                            break;
                        }
                    }
                    this.setState({ items: items });
                }
            });

        }
        else if (action_name === "highlight_action") {
            let session = window.localStorage;
            axios.post(session.ch_action_url + "/action/update_post_highlight_status", Qs.stringify({
                token: session.ch_token,
                id: id,
                value: value
            })).then(res => {
                if (res.data.status === -1) {
                    clearSession();
                }
                else if (res.data.status === 0) {
                    Swal.fire(
                        'Operation Failed!',
                        res.data.info,
                        'error');
                }
                else {
                    let items = this.state.items;
                    for (let i = 0; i < items.length; i++) {
                        if (items[i].id === id) {
                            items[i].highlight = value;
                            break;
                        }
                    }
                    this.setState({ items: items });
                }
            });
        }
        else if (action_name === "delete_post") {
            Swal.fire({
                title: "Deletion",
                text: "Are you sure to delete this?",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes'
            }).then((result) => {
                if (result.value) {
                    let session = window.localStorage;
                    axios.post(session.ch_action_url + "/action/delete_post", Qs.stringify({
                        token: session.ch_token,
                        id: id
                    })).then(res => {
                        if (res.data.status === -1) {
                            clearSession();
                        }
                        else if (res.data.status === 0) {
                            Swal.fire(
                                'Operation Failed!',
                                res.data.info,
                                'error');
                        }
                        else {
                            let items = this.state.items;
                            items = items.filter(item => (item.id != id));
                            this.setState({ items: items });
                        }
                    });
                }
            });

        }
        else if (action_name === "create_new_event") {
            let url = window.location.origin + "/event_editor/0";
            window.open(url, "_blank");
        }
    }

    handleSearchAction(e, action_name) {
        if (action_name === "keydown") {
            if (e.key === "Enter" && e.target.value !== "") {
                this.setState({ searchValue: e.target.value });
            }
        }
        else if (action_name === "onchange") {
            this.setState({ searchValue: e.target.value });
        }
    }

    handleSearchFilter(item) {
        if (this.state.searchValue === "" || (this.state.searchValue !== "" && (item.title.indexOf(this.state.searchValue) >= 0))) {
            return true;
        }

        if ((this.state.searchValue !== "" && (item.uname.indexOf(this.state.searchValue) >= 0))) {
            return true;
        }

        return false;
    }


    handleViewSingleEvent(e, id) {
        if (e !== null) {
            e.preventDefault();
        }
        this.props.handleViewSingleEvent(id);
    }


    openLightbox(post_id, index) {

        let posts = this.state.items;
        let post = null;
        for (let i = 0; i < posts.length; i++) {
            if (posts[i].id === post_id) {
                post = posts[i];
                break;
            }
        }
        let images = [];
        for (let i = 0; i < post.images.length; i++) {
            images.push(getRealImageSrc(post.images[i].src))
        }
        this.setState({ current_lightbox_images: images, currentPostImageIndex: index, viewerIsOpen: true });
    }

    closeLightbox() {
        this.setState({ current_lightbox_images: [], currentPostImageIndex: 0, viewerIsOpen: false });
    };


    renderSelectImages({
        index,
        left,
        top,
        photo }, post_id, image_size) {

        let margin = "2px";
        let imgStyle = {
            transition: "transform .135s cubic-bezier(0.0,0.0,0.2,1),opacity linear .15s",
            width: "100%",
            height: "100%"
        };
        let selectedImgStyle = {
            transform: "translateZ(0px) scale3d(0.9, 0.9, 1)",
            transition: "transform .135s cubic-bezier(0.0,0.0,0.2,1),opacity linear .15s",
            width: "100%",
            height: "100%"
        };
        let cont = {
            backgroundColor: "#eee",
            cursor: "pointer",
            overflow: "hidden",
            position: "relative"
        };

        //calculate x,y scale
        let sx = (100 - (30 / photo.width) * 100) / 100;
        let sy = (100 - (30 / photo.height) * 100) / 100;
        selectedImgStyle.transform = `translateZ(0px) scale3d(${sx}, ${sy}, 1)`;

        // if (direction === "column") {
        //   cont.position = "absolute";
        //   cont.left = left;
        //   cont.top = top;
        // }
        let maxWidth = 500;
        let maxHeight = 350;
        if (photo.height > photo.width) {
            maxWidth = maxHeight * (photo.width / photo.height);
        }
        else {
            maxHeight = maxWidth * (photo.height / photo.width);
        }
        //maxHeight:maxHeight+"px", maxWidth:maxWidth+"px",
        return (
            <div
                style={image_size > 1 ? { margin, height: photo.height, width: photo.width, ...cont } : { margin, maxHeight: maxHeight + "px", maxWidth: maxWidth + "px", height: photo.height, width: photo.width, ...cont }}
                className={"not-selected"}>
                <img
                    alt={photo.title}
                    style={{ ...imgStyle }}
                    {...{ "src": getRealImageSrc(photo.src) }}
                    onClick={() => this.openLightbox(post_id, index)}
                />
                <style>{`.not-selected:hover{outline:2px solid #06befa}`}</style>
            </div>
        );

    }


    getImageInstance(images) {
        let instances = [];
        for (let i = 0; i < images.length; i++) {
            let temp = { src: images[i].src, width: 4, height: 3 };
            instances.push(temp);
        }
    }

    showPostAllContent(e, id) {
        e.preventDefault();
        //current_top_position=this.
        let all_post = document.getElementById("content_all_" + id);
        let short_post = document.getElementById("content_short_" + id);
        let collasp_button = document.getElementById("hide_content_all_" + id);
        short_post.style.display = "none";
        all_post.style.display = "block";
        collasp_button.style.display = "block";
    }

    hidePostAllContent(id) {
        let post_div = document.getElementById(id);
        let all_post = document.getElementById("content_all_" + id);
        let short_post = document.getElementById("content_short_" + id);
        let collasp_button = document.getElementById("hide_content_all_" + id);
        all_post.style.display = "none";
        collasp_button.style.display = "none";
        short_post.style.display = "block";
        post_div.scrollIntoView();
    }

    isReadMore(info) {
        let just_info = this.extractContent(info, true);
        if (just_info.length > 100) {
            return 1;
        }
        else {
            return 0;
        }
    }

    getShortInfo(info) {
        let just_info = this.extractContent(info, true);
        return just_info.substring(0, 100) + " ...";
    }

    extractContent(s, space) {
        var span = document.createElement('span');
        span.innerHTML = s;
        if (space) {
            var children = span.querySelectorAll('*');
            for (var i = 0; i < children.length; i++) {
                if (children[i].textContent)
                    children[i].textContent += ' ';
                else
                    children[i].innerText += ' ';
            }
        }
        return [span.textContent || span.innerText].toString().replace(/ +/g, ' ');
    };

    render() {
        return (
            <Fragment>
                <PerfectScrollbar options={{ suppressScrollX: true, wheelPropagation: true }}>
                    <div className="pt-2 pb-3" id="show_main_content_div_post" style={{ height: "calc(100vh - 90px)" }}>
                        <div className="pb-3 pt-2" style={{ maxWidth: "820px", margin: "auto" }}>
                            <div className="d-flex justify-content-between p-2 align-items-center" style={{ borderBottom: "1px gray solid" }}>
                                <div className="d-flex">
                                    <div className="ml-2 search-wrapper is-active">
                                        <span className="icon-wrapper text-black">
                                            <FontAwesomeIcon icon={['fas', 'search']} />
                                        </span>
                                        <Input id="file_body_search" key="file_body_search" style={{ borderColor: "#b2b3cc" }} onKeyPress={(e) => this.handleSearchAction(e, "keydown")} onChange={(e) => this.handleSearchAction(e, "onchange")} className="rounded-pill" placeholder={"searching..."} type="search" />
                                    </div>
                                </div>
                                {this.state.is_admin === 1 && <div className="d-flex">
                                    <div className="pl-3 pt-2 pb-2">
                                        <Button className="ml-2 btn-primary" color="primary" onClick={(e) => this.handlePostActions(null, "create_new_event")} size="sm" key="create_new_event_button" id="create_new_event_button" >Create Event</Button>
                                    </div>
                                </div>}
                            </div>
                            <div className="align-items-center justify-content-center loader_100" id="post_modal_loader" style={{ width: "100%", display: "none" }}>
                                <Progress value="100" striped animated className="progress-bar progress-animated-alt" color="warning" >Loading Data, please wait...</Progress>
                            </div>
                            <div className="p-2">
                                {this.state.items.length > 0 && this.state.items.map(post => (
                                    this.handleSearchFilter(post) &&
                                    <Card className="mb-3" key={"card_" + post.id} style={{ maxWidth: "800px", margin: "auto" }} id={post.id}>
                                        <CardHeader className="border-0">
                                            {post.top === 1 && <span className="ribbon-angle ribbon-angle--top-left ribbon-warning">
                                                <small>Highlight</small>
                                            </span>}
                                            <div className="d-flex justify-content-between mb-1">
                                                <div style={{ paddingLeft: post.top === 1 ? "3rem" : "0px" }}>
                                                    <div className="pl-0">
                                                        <a className="font-weight-bold font-size-lg text-black" href="" onClick={(e) => e.preventDefault()}>
                                                            {post.title}
                                                        </a>

                                                    </div>
                                                    <div className="d-flex">
                                                        <small className="text-black-50 pt-1 d-block">
                                                            by: <b className="text-first">{post.uname}</b>
                                                        </small>
                                                        <small className="text-black-50 pt-1 d-block ml-2">
                                                            on: <b className="text-first">{post.datetime}</b>
                                                        </small>
                                                    </div>
                                                </div>
                                                <div className="card-header--actions card-tr-actions d-flex">
                                                    {post.user_role == 1 &&
                                                        <UncontrolledDropdown className="ml-2">
                                                            <DropdownToggle color="link" className="btn-link-first p-0 font-size-xl text-first no-caret">
                                                                <FontAwesomeIcon icon={['fas', 'angle-down']} />
                                                            </DropdownToggle>
                                                            <DropdownMenu right >
                                                                <div role="menuitem">
                                                                    <Link className="dropdown-item" to={"/event_editor/" + post.id} target="_blank">Edit</Link></div>
                                                                {post.top == 0 && <div role="menuitem"><a className="dropdown-item" href="#/" onClick={e => this.handlePostActions(e, "top_action", post.id, 1)}>Highlight</a></div>}
                                                                {post.top == 1 && <div role="menuitem"><a className="dropdown-item" href="#/" onClick={e => this.handlePostActions(e, "top_action", post.id, 0)}>Un-Highlight</a></div>}
                                                                {false && post.highlight == 0 && <div role="menuitem"><a className="dropdown-item" href="#/" onClick={e => this.handlePostActions(e, "highlight_action", post.id, 1)}>Highlight</a></div>}
                                                                {false && post.highlight == 1 && <div role="menuitem"><a className="dropdown-item" href="#/" onClick={e => this.handlePostActions(e, "highlight_action", post.id, 0)}>Un-Highlight</a></div>}
                                                                <div className="divider dropdown-divider" />
                                                                <div role="menuitem"><a className="dropdown-item" href="#/" onClick={e => this.handlePostActions(e, "delete_post", post.id)}>Delete</a></div>
                                                            </DropdownMenu>
                                                        </UncontrolledDropdown>}
                                                </div>
                                            </div>

                                        </CardHeader>
                                        <div className="card-body pt-0" >
                                            {this.isReadMore(post.content) == 1 && <div className="content_intro" id={"content_short_" + post.id}>
                                                <span>{this.getShortInfo(post.content)}</span>
                                                <Button tag="a" href="#/" onClick={e => this.showPostAllContent(e, post.id)} color="link" className="btn-link-first p-0" title="read more"><span>read more</span></Button>
                                            </div>}

                                            <div id={"content_all_" + post.id} className="post_all_content" style={{ display: this.isReadMore(post.content) == 1 ? "none" : "block" }} dangerouslySetInnerHTML={{ __html: post.content }} />
                                            <Button id={"hide_content_all_" + post.id} size="sm" outline onClick={e => this.hidePostAllContent(post.id)} color="first" style={{ display: "none" }} className="btn-pill mt-1">Collapsed</Button>
                                            {post.images !== undefined && post.images.length > 0 && <Gallery photos={post.images} renderImage={({ index, left, top, photo }) => this.renderSelectImages({ index, left, top, photo }, post.id, post.images.length)} />}
                                        </div>
                                    </Card>
                                ))}

                            </div>
                        </div>
                    </div>
                </PerfectScrollbar>
                {this.state.viewerIsOpen && (
                    <Lightbox
                        mainSrc={this.state.current_lightbox_images[this.state.currentPostImageIndex]}
                        nextSrc={this.state.current_lightbox_images[(this.state.currentPostImageIndex + 1) % this.state.current_lightbox_images.length]}
                        prevSrc={this.state.current_lightbox_images[(this.state.currentPostImageIndex + this.state.current_lightbox_images.length - 1) % this.state.current_lightbox_images.length]}
                        onCloseRequest={() => this.setState({ viewerIsOpen: false })}
                        onMovePrevRequest={() =>
                            this.setState({
                                currentPostImageIndex: (this.state.currentPostImageIndex + this.state.current_lightbox_images.length - 1) % this.state.current_lightbox_images.length,
                            })
                        }
                        onMoveNextRequest={() =>
                            this.setState({
                                currentPostImageIndex: (this.state.currentPostImageIndex + 1) % this.state.current_lightbox_images.length,
                            })
                        }
                    />
                )}
            </Fragment>
        );
    }
}